import Vue from 'vue'
export var eventBus = new Vue();


// WEBPACK FOOTER //
// ./src/common/scripts/eventBus.js